import { Direction, Flex } from "@ntemarked/mittne-components/dist/Flex/Flex";

import { DeleteButton } from "components/atoms/DangerButton";
import { useModalButtonContext } from "components/organisms/ModalButton";
import { DeviceDetailsFragment, useDeleteDeviceMutation, UserDetailsFragment } from "pages/Users/Users.graphql-gen";

export default function DeleteDeviceModal({ user, device }: { user: UserDetailsFragment; device: DeviceDetailsFragment }) {
	const { close } = useModalButtonContext();
	const [deleteDeviceMutation] = useDeleteDeviceMutation({
		refetchQueries: ["getUser"],
	});

	async function handleDeleteDevice() {
		if (device.deviceId && user.userId) {
			await deleteDeviceMutation({
				variables: {
					userid: user.userId,
					deviceid: device.deviceId,
				},
			});
			close();
		}
	}

	return (
		<Flex
			direction={Direction.column}
			style={{
				width: "400px",
				padding: "16px",
			}}
		>
			<p>Er du sikker på at du vil slette følgende enhet?</p>

			<li>{device.name}</li>
			<DeleteButton onClick={handleDeleteDevice}>Slett enhet</DeleteButton>
		</Flex>
	);
}
